import { LoadingButton } from "@mui/lab";
import { Box, Button, Stack, Typography } from "@mui/material";
import CheckboxControl from "components/form/CheckboxControl";
import TextFieldControl from "components/form/TextFieldControl";
import VALIDATION from "helpers/validation";
import { FIELD_LABEL_PROPS } from "../constants";
import StepSection from "./StepSection";

type ManagerStepProps = {
  isCompanyLeader: boolean;
  isSubmitting: boolean;
  onNextStep: () => void;
  onPreviousStep: () => void;
};

const ManagerStep = ({ isCompanyLeader, isSubmitting, onNextStep, onPreviousStep }: ManagerStepProps) => (
  <StepSection title='Руководитель'>
    <TextFieldControl
      name='leaderFullName'
      label='Ваше ФИО'
      variant='outlined'
      labelTypographyProps={FIELD_LABEL_PROPS}
      placeholder='Иванов Иван Иванович'
      rules={{ required: true, ...VALIDATION.fullUserName }}
    />

    <CheckboxControl
      name='isCompanyLeader'
      label='Являюсь руководителем компании'
      sx={{
        mt: -0.5,
        m: 0,
        "& .MuiFormControlLabel-label": { color: "#081B3A", fontSize: 18 },
      }}
    />

    {!isCompanyLeader && (
      <Stack spacing={3}>
        <TextFieldControl
          name='userPosition'
          label='Ваша должность'
          variant='outlined'
          labelTypographyProps={FIELD_LABEL_PROPS}
          placeholder='Например, HR-директор'
          rules={{ required: true, ...VALIDATION.position }}
        />

        <TextFieldControl
          name='managerFio'
          label='Руководитель юр.лица — ФИО'
          variant='outlined'
          labelTypographyProps={FIELD_LABEL_PROPS}
          placeholder='ФИО директора'
          rules={{ required: true, ...VALIDATION.fullUserName }}
        />
      </Stack>
    )}

    <Box
      sx={{
        borderRadius: 2.5,
        backgroundColor: "#EEF0FF",
        border: "1px solid #D5CCFF",
        px: 2.5,
        py: 2.25,
      }}>
      <Typography sx={{ color: "#4F2BD4", fontWeight: 700, fontSize: 18 }}>
        Вы становитесь Руководителем пространства
      </Typography>
      <Typography sx={{ mt: 1, color: "#4F2BD4", fontSize: 17, lineHeight: 1.45 }}>
        Полные права на компанию, включая удаление. Это роль на платформе — она может отличаться от юридического
        руководителя.
      </Typography>
    </Box>

    <Stack
      direction='row'
      alignItems='center'
      spacing={2}>
      <Button
        variant='text'
        size='large'
        sx={{ minWidth: 96, px: 0, color: "#1C3366", fontSize: 18, fontWeight: 500 }}
        onClick={onPreviousStep}>
        Назад
      </Button>

      <LoadingButton
        loading={isSubmitting}
        variant='contained'
        size='large'
        fullWidth
        onClick={onNextStep}>
        Далее
      </LoadingButton>
    </Stack>
  </StepSection>
);

export default ManagerStep;
